/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GroupMembershipFullList } from '../models/GroupMembershipFullList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GroupsMembershipFullService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Returns a full membership list.
     * @returns any OK
     * @throws ApiError
     */
    public getGroupMembershipFullList({
        groupIds,
    }: {
        /**
         * Filter by group ids.
         */
        groupIds?: Array<number>,
    }): CancelablePromise<{
        data: Array<GroupMembershipFullList>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/group-membership',
            query: {
                'group_ids': groupIds,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
